import { useEffect, useState } from 'react';
import { IAddAddress, IListItem, IResultsData, IResultsServerProps } from '@pro/activity/testerClub/interface';
import { addAddress, getEarlyAccessResults } from '@pro/activity/testerClub/services';
import Message from '@base/lib/Message';

export type IUseEarlyAccessResults = {
    resultsData?: IResultsData;
    onAddressForm: (params: IAddAddress) => Promise<any>;
    isLoading: boolean;
}

type IProps = {
    product: IListItem;
}

export function useEarlyAccessResultsModal(props: IProps): IUseEarlyAccessResults {

    const { product } = props

    const [resultsData, setResultsData] = useState<IResultsData>()
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const getResults = async () => {
        try {
            setIsLoading(true)
            const res = await getEarlyAccessResults({
                activityGid: product?.activityGid || ''
            })

            setResultsData(res)
        } catch (err) {
            Message.error(err.message)
        } finally {
            setIsLoading(false)
        }
    }

    const onAddressForm = async (data: IAddAddress) => {
        try {

            const res = await addAddress(data)
            if (res) {
                await getResults().then()
            }
        } catch (err) {
            Message.error(err.message)
        }
    }

    useEffect(() => {
        if (!!product) {
            getResults().then()
        }
    }, [product])

    return {
        resultsData,
        onAddressForm,
        isLoading
    }
}